import { View } from '@react-pdf/renderer';
import { styles } from '../PDFStyle';
import PDFTableHeader from './PDFTableHeader';

interface IPDFTableProps {
    columns: string[];
    data: string[][];
}

const PDFTable = (props: IPDFTableProps) => {
    return (
        <View>
            <View break style={[styles.row, styles.borderRow, styles.headerTable]}>
                <PDFTableHeader columns={props.columns} />
            </View>
            {props.data.map((data, index) => {
                let color = index % 2 == 0 ? '#dee0e1' : '#fff';
                return (
                    <View style={[styles.row, styles.borderRow, { backgroundColor: color }]} key={index}>
                        <PDFTableHeader columns={data} />
                    </View>
                );
            })}
        </View>
    );
};

export default PDFTable;
